import React from 'react'
import { Accordion } from "react-bootstrap";


export default function DynamicPageFaqs({ data }) {
      if (!data) return null;
  return (
    <>
      <section className='finaldataintegfaq-area quicklinkfaq-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <span>FREQUENTLY ASKED QUESTIONS</span>
              <h4 className='heading'>Your questions, our answers</h4>
              <Accordion defaultActiveKey="0">
                {data?.faqs && data?.faqs?.map((item, index) => (
                  <Accordion.Item key={index} eventKey={`${index}`}>
                    <Accordion.Header>
                      {item?.question}
                    </Accordion.Header>
                    <Accordion.Body>
                      {item?.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
